/**
 * Размеры карточки «Готовых шаблонов» — общие для живой карточки и её скелетона (IMGM-1618).
 * Лёгкий файл без зависимостей: скелетон не должен тянуть за собой Fabric-канву карточки
 * (`.claude/docs/skeleton-kit.md`).
 */

/** Ширина карточки — она же ширина колонки сетки каталога. */
export const CATALOG_CARD_WIDTH = 340;
/** Высота превью табло. */
export const CATALOG_PREVIEW_HEIGHT = 160;
/** Отступ строки «название · лайки · просмотры» от превью. */
export const CATALOG_CAPTION_GAP = 8;
/** Отступ строки автора от строки названия. */
export const CATALOG_OWNER_GAP = 2;
